module.exports = __webpack_public_path__ + "static/media/terms-of-service.f58cbe67.md";